import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.selector)
  }, [
    _createVNode(_TransitionGroup, {
      name: "fade",
      class: "img-container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoUri, (photo, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "img-container-inner",
            key: `photo-${index}`
          }, [
            _createElementVNode("img", { src: photo }, null, 8, _hoisted_1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 2))
}